import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { PasswordModule } from 'primeng/password';

@Component({
  selector: 'kon-password-type',
  imports: [PasswordModule, ReactiveFormsModule],
  template: `
    <p-password
      [formControl]="$any(formControl)"
      [toggleMask]="true"
      [feedback]="false"
      [style]="{ width: '100%' }"
      [placeholder]="props.placeholder"
      [autocomplete]="props['autocomplete']"
    ></p-password>
  `,
  styles: ``,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyPasswordTypeComponent extends FieldType<FormlyFieldConfig> {}
